<template>
  <div>
    <ChapterHead>
      <span>费用编号：{{formData.outlayId}}</span>
      <span slot="extra">
        <!-- <el-button :loading="loading" type="primary" v-if="!localReadOnly" icon="el-icon-s-release" size="mini" @click="saveData">暂存</el-button>
        <el-button :loading="loading" type="primary" v-if="!localReadOnly" icon="el-icon-success" size="mini" @click="submitData">提交</el-button> -->
        <el-button type="primary" v-if="['todo', 'timeout'].indexOf(localActive) > -1" icon="el-icon-success" size="mini" @click="giveUpData">放弃</el-button>
<!--        <el-button :loading="loading" type="primary" icon="el-icon-close" size="mini" @click="closeDetail">关闭</el-button>-->
      </span>
    </ChapterHead>
    <el-form ref="formData" :loading="loading" :model="formData" :rules="formRules" :inline="true" label-width="180">
      <el-row>
        <el-col :span="6">
          <el-form-item label="救助医院" prop="hospitalName">
            <el-input type="text" disabled v-model="formData.hospitalName" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="病种" prop="beforeDiseasesIdList">
            <DiseaseCascader
              v-model="formData.beforeDiseasesIdList"
              :hospitalId="formData.hospitalId"
              :multiple="true"
              :disabled="true"
              :all="true"
            ></DiseaseCascader>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="救助限额：" prop="specialQuota">
            <el-input type="text" :value="parseFloat(formData.specialQuota || 0).toFixed(2)" :disabled="true" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="检查时间" prop="checkTime">
            <el-date-picker
              v-model="formData.checkTime"
              align="right"
              size="small"
              type="date"
              placeholder="选择时间"
              :disabled="localReadOnly"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="发票张数" prop="billCount">
            <NumberInput v-model="formData.billCount" :disabled="localReadOnly"></NumberInput>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="检查费用" prop="checkOutlay">
            <el-input v-if="readOnly" :value="parseFloat(formData.checkOutlay || 0).toFixed(2)" disabled />
            <MoneyInput v-else v-model="formData.checkOutlay" :disabled="localReadOnly"></MoneyInput>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="救助费用" prop="helpAmount">
            <el-input v-if="readOnly" :value="parseFloat(formData.helpAmount || 0).toFixed(2)" disabled />
              <MoneyInput v-else v-model="formData.helpAmount" :disabled="localReadOnly"></MoneyInput>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="formData.remark" :rows="3" :disabled="localReadOnly"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="发票附件" prop="attachList">
        <FileUpload v-model="formData.attachList" :disabled="localReadOnly"></FileUpload>
      </el-form-item>
    </el-form>
    <ChapterHead v-if="localReadOnly">辅助信息</ChapterHead>
    <OutlayOtherInfo v-if="localReadOnly" :formData="formData"></OutlayOtherInfo>
    <OutlayGiveUpDialog v-if="giveUpVisible" :outlayId="formData.outlayId" :visible="giveUpVisible" @success="giveUpSuccess" @close="giveUpVisible = false"></OutlayGiveUpDialog>
  </div>
</template>

<script>
import { getOutlayDataById, saveCheckOutlay, submitCheckOutlay } from "@/util/api.js";
import DictionarySelect from "@/components/business/DictionarySelect";
import DiseaseCascader from "@/components/business/DiseaseCascader";
import FileUpload from "@/components/business/FileUpload";
import MoneyInput from "@/components/business/MoneyInput";
import NumberInput from "@/components/business/NumberInput";
import ChapterHead from "@/components/business/ChapterHead";
import OutlayOtherInfo from './OutlayOtherInfo'
import OutlayGiveUpDialog from './OutlayGiveUpDialog'

export default {
  components: {
    ChapterHead,
    DictionarySelect,
    DiseaseCascader,
    FileUpload,
    MoneyInput,
    NumberInput,
    OutlayOtherInfo,
    OutlayGiveUpDialog
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    active: String,
    readOnly: false,
    recordId: {
      type: String
    }
  },
  data() {
    const _this = this;
    return {
      isShow: this.dialogVisible,
      localActive: this.active,
      giveUpVisible: false,
      dialogImageUrl: "",
      disabled: false,
      loading: false,
      localReadOnly: true,
      formData: {},
      formRules: {
        checkTime: [{ required: true, message: '请选择检查时间', trigger: 'blur' }],
        billCount: [{ required: true, message: '请输入发票张数', trigger: 'blur' }],
        checkOutlay: [{ required: true, message: '请输入检查费用', trigger: 'blur' }],
        helpAmount: [
          { required: true, message: '请输入救助费用', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (parseFloat(value || 0) > parseFloat(_this.formData.specialQuota || 0)) {
              callback('救助费用不能超过救助限额');
            } else if (_this.formData.checkOutlay && parseFloat(value || 0) > parseFloat(_this.formData.checkOutlay)) {
              callback('救助费用不能超过检查费用')
            } else {
              callback();
            }
          }, trigger: 'blur'}
        ],
      },
      helpRequestData: {}
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData() {
      if (this.recordId) {
        this.loading = true;
        getOutlayDataById(this.recordId).then(res => {
          this.loading = false;
          if (res.msgCode == 200) {
            this.formData = res.responseData;
            if (this.formData.beforeDiseasesList && this.formData.beforeDiseasesList.length > 0) {
              this.formData.beforeDiseasesIdList = this.formData.beforeDiseasesList.map(dis => {
                return dis.diseasesId;
              });
            }
            // this.localReadOnly = this.readOnly || this.formData.outlayStatus != 0;
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    saveData () {
      this.loading = true;
      saveCheckOutlay(this.formData).then(res => {
        this.loading = false;
        if (res.msgCode == 200) {
          this.$message.success('暂存成功！');
          this.closeDetail();
          this.$emit('success', this.formData);
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    submitData () {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.loading = true;
          submitCheckOutlay(this.formData).then(res => {
            this.loading = false;
            if (res.msgCode == 200) {
              this.$message.success('提交成功！');
              this.closeDetail();
              this.$emit('success', this.formData);
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      });
    },
    giveUpData () {
      this.giveUpVisible = true;
    },
    giveUpSuccess () {
      this.$emit('success', this.formData);
      this.closeDetail();
    },
    closeDetail() {
      this.$emit("update:dialogVisible", false);
      this.$emit('close');
    },
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/common/form.scss';
</style>



// WEBPACK FOOTER //
// src/pages/outlay/view/CheckOutlayDetail.vue